export default "__VITE_ASSET__BjCwwnb2__"